import { TwillImage } from '../../vendor/area17/twill-image/dist/index';

const lazyloading = new TwillImage();

export default lazyloading;
